import { createContext, useContext, useReducer, useCallback, useState } from "react";
import { dbReducer, initDB } from "../../reducers/formflow/dbReducer";

const AppContext = createContext();

export function AppProvider({ children }) {
  const [db, dispatch] = useReducer(dbReducer, initDB);
  const [toast, setToast] = useState(null);

  const showToast = useCallback((msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  }, []);

  return <AppContext.Provider value={{ db, dispatch, showToast, toast }}>{children}</AppContext.Provider>;
}

export function useApp() {
  return useContext(AppContext);
}

// import React, { createContext, useContext, useReducer, useEffect } from "react";
// import * as formApi from "../api/formApi";
// import { dbReducer, initDB } from "../../reducers/formflow/dbReducer";

// const AppContext = createContext();

// export function AppProvider({ children }) {
//   const [db, dispatch] = useReducer(dbReducer, initDB);

//   // useEffect(() => {
//   //   const loadForms = async () => {
//   //     try {
//   //       const { forms } = await formApi.fetchFormsFromServer();
//   //       forms.forEach((form) => {
//   //         dispatch({ type: "SAVE_FORM", form });
//   //       });
//   //     } catch (error) {
//   //       console.error("Failed to load forms", error);
//   //     }
//   //   };
//   //   loadForms();
//   // }, []);

//   const saveForm = async (form, file) => {
//     try {
//       const savedForm = await formApi.createFormOnServer(form, file);
//       dispatch({ type: "SAVE_FORM", form: form });
//       return { success: true };
//     } catch (error) {
//       console.error("Save failed", error);
//       return { success: false, error };
//     }
//   };

//   const deleteForm = async (formId) => {
//     try {
//       // await formApi.deleteFormOnServer(formId);
//       dispatch({ type: "DELETE_FORM", id: formId });
//       return { success: true };
//     } catch (error) {
//       console.error("Delete failed", error);
//       return { success: false, error };
//     }
//   };

//   const sendForm = async (payload) => {
//     try {
//       // const submission = await formApi.sendSubmissionToServer(payload);
//       dispatch({ type: "SEND_FORM", payload });
//       return { success: true };
//     } catch (error) {
//       console.error("Send failed", error);
//       return { success: false, error };
//     }
//   };

//   const submitFields = async (submissionId, recipientId, fields) => {
//     try {
//       // const updatedFields = await formApi.submitFieldsToServer(submissionId, recipientId, fields);
//       dispatch({ type: "SUBMIT_FIELDS", submissionId, recipientId, fields });
//       return { success: true };
//     } catch (error) {
//       console.error("Submit fields failed", error);
//       return { success: false, error };
//     }
//   };

//   const showToast = (message, type = "info") => {
//     console.log(`[${type}] ${message}`);
//   };

//   return <AppContext.Provider value={{ db, dispatch, saveForm, deleteForm, sendForm, submitFields, showToast }}>{children}</AppContext.Provider>;
// }

// export function useApp() {
//   return useContext(AppContext);
// }
